module.exports = __webpack_public_path__ + "img/download-new-active.7c1f97bb.svg";